import { MobileAutomationService } from '@app/mobile-automation/mobile-automation.service';
import { Component, Input, OnInit } from '@angular/core';
import { environment } from '@environments/environment';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { UserService } from '@app/user/user.service';

@Component({
  selector: 'app-mobile-screen-shot-modal',
  templateUrl: './mobile-screen-shot-modal.component.html',
  styleUrls: ['./mobile-screen-shot-modal.component.less']
})
export class MobileScreenShotModalComponent implements OnInit {
  @Input() mobileInstructionDetails: any;
  @Input() gridFsId: any;
  @Input() gridFsName: any;
  @Input() fileName: any;
  @Input() fileId: any;
  @Input() mostRecentExecuted: any;
  @Input() hideExportButton: any;
  @Input() nonMobileTrack: any;
  @Input() resultFile: any;

  lgScreenShot: any;
  screenShotModal: any = this.activeModal;

  constructor(public activeModal: NgbActiveModal, private mobileAutomationService: MobileAutomationService,
    private Toastr: ToastrService, private userService: UserService,     private toastr: ToastrService  ) { }

  ngOnInit(): void {
    this.initialiseScreenShot();
  }

  dataURItoBlob(dataURI) {
    var byteString;
            if (dataURI.split(',')[0].indexOf('base64') >= 0)
                byteString = atob(dataURI.split(',')[1]);
            else
                byteString = unescape(dataURI.split(',')[1]);
            // separate out the mime component
            var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];
            // write the bytes of the string to a typed array
            var ia = new Uint8Array(byteString.length);
            for (var i = 0; i < byteString.length; i++) {
                ia[i] = byteString.charCodeAt(i);
            }
            return new Blob([ia], {type:mimeString});
 }
 

  exportImage(path) {
    const imageBlob = this.dataURItoBlob(path.path);
    const imageFile =new File([imageBlob], this.gridFsName, {
      type: "'image/jpeg'"
    });
    let formData = new FormData();
    formData.append("file0", imageFile);
    this.userService.uploadFile(this.mostRecentExecuted.environment.projectSqlId, formData, false, false, false, false, this.gridFsName).subscribe(data => {
          if (data.code == 200) {
        this.toastr.success("file uploaded successfully");
      } else {
        this.toastr.error(data.message);
      }
    });
  }

  initialiseScreenShot(): void {
    if (this.mobileInstructionDetails) {
      const mobileInstructionDetails = this.mobileInstructionDetails;
      this.lgScreenShot = {
        name: mobileInstructionDetails.name
      };
      this.loadScreenShot(mobileInstructionDetails);
    }
  }

  loadScreenShot(webInstruction: any): void {
    let tempObject = {
        fileId: this.gridFsId,
        fileName: this.gridFsName,
        executionId: this.mostRecentExecuted && this.mostRecentExecuted.execution.noSqlId,
        mobileInstructionId: this.mobileInstructionDetails && this.mobileInstructionDetails.noSqlId
      }
    if(this.mobileInstructionDetails && !this.nonMobileTrack) {
      this.mobileAutomationService.getSelectedMobileInstructionScreenshotS3(tempObject).subscribe(data => {
        if (data) {
        this.lgScreenShot.path = 'data:image/JPEG;base64,' + data.response.content;
        webInstruction.mobileScreenshot = data.response;
        }
      }, (err) => {
        this.Toastr.error('Failed to fetch image');
      });
    }
    
    if (this.mobileInstructionDetails && this.nonMobileTrack && this.resultFile) {
      this.mobileAutomationService.getSelectedNonMobileResultExtractorScreenshot(tempObject).subscribe(data => {
        if (data) {
          this.lgScreenShot.path = 'data:image/JPEG;base64,' + data.response.content;
          webInstruction.mobileScreenshot = data.response;
        }
      }, (err) => {
        this.Toastr.error('Failed to fetch image');
      });
    }

    if (this.mobileInstructionDetails && this.nonMobileTrack && !this.resultFile) {
      this.mobileAutomationService.getSelectedNonMobileInstructionScreenshotS3(this.fileId).subscribe(data => {
        if (data) {
          this.lgScreenShot.path = 'data:image/JPEG;base64,' + data.response.content;
          webInstruction.mobileScreenshot = data.response;
        }
      }, (err) => {
        this.Toastr.error('Failed to fetch image');
      });
    }
    // if(this.mobileInstructionDetails) {
    //   this.mobileAutomationService.getSelectedMobileInstructionScreenshot(this.gridFsId).subscribe(data => {
    //     if (data) {
    //     this.lgScreenShot.path = 'data:image/JPEG;base64,' + data.response.content;
    //     webInstruction.mobileScreenshot = data.response;
    //     }
    //   }, (err) => {
    //     this.Toastr.error('Failed to fetch image');
    //   });
    // }
  }

  downloadFile(): void {
    if (this.mostRecentExecuted) {
      window.open(`${environment.apiUrl}file/mobile/download?fileId=${this.gridFsId}&fileName=${this.gridFsName}&executionId=${this.mostRecentExecuted.execution.noSqlId}&mobileInstructionId=${this.mobileInstructionDetails.noSqlId}`);

    } else {
      const downloadFileName = this.fileName ? this.fileName : this.gridFsName;
      const url = this.resultFile ? `${environment.apiUrl}file/result/download?`+`fileId=${this.gridFsId}&fileName=${downloadFileName}`+`&executionId=${null}&mobileInstructionId=${null}` : `${environment.apiUrl}file/download/file?`+`gridFsId=${this.gridFsId}&fileName=${downloadFileName}`+`&fileType=${this.fileId}`;
      window.open(url);
    }
  }

}